import {
  createDeleteRequest,
  createPostRequest,
  createRequest,
  createPatchRequest,
} from 'lp-redux-api'

/*** UNAUTHENTICATED REQUESTS */

export const authenticateUser = createPostRequest(
  'AUTHENTICATE_USER',
  (credentials, loginType) => ({
    url: '/api/v1/login',
    body: { user: credentials, login_type: loginType },
  })
)

export const requestPasswordReset = createPostRequest(
  'REQUEST_RESET_PASSWORD',
  (credentials) => ({
    url: '/api/v1/password',
    body: { user: credentials },
  })
)

export const resetPassword = createPatchRequest(
  'RESET_PASSWORD',
  (passwordParams) => ({
    url: '/api/v1/password',
    body: { user: passwordParams },
  })
)

export const createAccount = createPatchRequest(
  'CREATE_ACCOUNT',
  (passwordParams) => ({
    url: '/api/v1/invitation',
    body: { user: passwordParams },
  })
)

/*** AUTHENTICATED REQUESTS */

export const fetchCurrentUser = createRequest('FETCH_CURRENT_USER', () => ({
  url: '/api/v1/current_user',
  authenticated: true,
}))

export const logOutUser = createDeleteRequest('LOG_OUT', () => ({
  url: '/api/v1/logout',
  authenticated: true,
}))

export const fetchWorkOrder = createRequest('FETCH_WORK_ORDER', (id) => ({
  url: `/api/v1/work_orders/${id}`,
  authenticated: true,
}))

export const fetchManagerWorkOrder = createRequest(
  'FETCH_MANAGER_WORK_ORDER',
  (id) => ({
    url: `/api/v1/manager/work_orders/${id}`,
    authenticated: true,
  })
)

export const searchWorkOrder = createRequest('SEARCH_WORK_ORDER', (name) => ({
  url: `/api/v1/work_orders/search/${name}`,
  authenticated: true,
}))

export const createTrip = createPostRequest(
  'CREATE_TRIP',
  (data, coordinates) => ({
    url: '/api/v1/trips',
    body: { trip: data, coordinates },
    authenticated: true,
  })
)

export const updateTrip = createPatchRequest(
  'UPDATE_TRIP',
  (id, data, coordinates, questionResponses = []) => ({
    url: `/api/v1/trips/${id}`,
    body: { trip: data, coordinates, questionResponses },
    authenticated: true,
  })
)

export const createTripPhoto = createPostRequest(
  'CREATE_TRIP_PHOTO',
  (id, photo) => ({
    url: `/api/v1/trips/${id}/trip_photos`,
    body: { photo },
    authenticated: true,
  })
)

export const deleteTripPhoto = createDeleteRequest(
  'DELETE_TRIP_PHOTO',
  (id, photoId) => ({
    url: `/api/v1/trips/${id}/trip_photos/${photoId}`,
    authenticated: true,
  })
)

export const advanceQuestionnaire = createPostRequest(
  'ADVANCE_QUESTIONNAIRE',
  (tripId, questionResponses, questionnaireType) => ({
    url: `/api/v1/trips/${tripId}/questionnaire/advance`,
    body: { questionResponses, questionnaireType },
    authenticated: true,
  })
)

export const fetchManagerWorkOrderLists = createRequest(
  'FETCH_MANAGER_WORK_ORDER_LISTS',
  () => ({
    url: '/api/v1/manager/work_orders/lists',
    authenticated: true,
  })
)

export const fetchManagerWorkOrders = createRequest(
  'FETCH_MANAGER_WORK_ORDERS',
  () => ({
    url: '/api/v1/manager/work_orders',
    authenticated: true,
  })
)

export const acceptWorkOrder = createPostRequest(
  'ACCEPT_WORK_ORDER',
  (params) => ({
    url: `/api/v1/manager/work_orders/${params.workOrderId}/accept`,
    body: {
      work_order: {
        eta_date: params.eta_date,
        eta_time: params.eta_time,
        tech_comments: params.tech_comments,
      },
    },
    authenticated: true,
  })
)

export const declineWorkOrder = createPostRequest(
  'DECLINE_WORK_ORDER',
  (params) => ({
    url: `/api/v1/manager/work_orders/${params.workOrderId}/decline`,
    body: {
      work_order: {
        reason_for_declining: params.reason_for_declining,
      },
    },
    authenticated: true,
  })
)

export const rescheduleWorkOrder = createPostRequest(
  'RESCHEDULE_WORK_ORDER',
  (params) => ({
    url: `/api/v1/manager/work_orders/${params.workOrderId}/reschedule`,
    body: {
      work_order: {
        eta_date: params.eta_date,
        eta_time: params.eta_time,
        reschedule_reason: params.reschedule_reason,
      },
    },
    authenticated: true,
  })
)

export const inProgressResetEtaWorkOrder = createPostRequest(
  'IN_PROGRESS_RESET_ETA_WORK_ORDER',
  (params) => ({
    url: `/api/v1/manager/work_orders/${params.workOrderId}/in_progress_reset_eta`,
    body: {
      work_order: {
        eta_date: params.eta_date,
        eta_time: params.eta_time,
        tech_comments: params.tech_comments,
      },
    },
    authenticated: true,
  })
)

export const inProgressChangeStatusWorkOrder = createPostRequest(
  'IN_PROGRESS_CHANGE_STATUS_WORK_ORDER',
  (params) => ({
    url: `/api/v1/manager/work_orders/${params.workOrderId}/in_progress_change_status`,
    body: {
      work_order: {
        order_status: params.order_status,
        tech_comments: params.tech_comments,
      },
    },
    authenticated: true,
  })
)

export const addTechCommentsWorkOrder = createPostRequest(
  'ADD_TECH_COMMENTS_WORK_ORDER',
  (params) => ({
    url: `/api/v1/manager/work_orders/${params.workOrderId}/add_tech_comments`,
    body: {
      work_order: {
        tech_comments: params.tech_comments,
      },
    },
    authenticated: true,
  })
)

export const updateManagerWorkOrder = createPatchRequest(
  'UPDATE_MANAGER_WORK_ORDER',
  (params) => ({
    url: `/api/v1/manager/work_orders/${params.workOrderId}`,
    body: {
      work_order: {
        parts_order_po_number: params.partsOrderPoNumber,
      },
    },
    authenticated: true,
  })
)
